import { TicketItemModel as o } from "../ticketItem/ticketItem.model.js";
class m extends o {
  constructor(e) {
    super(e), this.items = e.items;
  }
}
export {
  m as TicketItemComboModel
};
//# sourceMappingURL=ticketItemCombo.model.js.map
